import { apiRequest } from "./apiRequest";

export interface AppConfigs {
  theme: string;
  domain: string;
  streams: number;
  filter_by: string[];
  show_logo: boolean;
  date_format: string[];
  show_author: boolean;
  show_qr_code: boolean;
  layout: string;
  items: number;
  location: string;
  default_image: string;
  slide_duration: number;
  available_calendars: {
    id: number;
    name: string;
  }[];
  temperature_unit: string;
  ticker: boolean;
  number_of_posts: number;
  theme_available: string[];
  show_stream_name: boolean;
  available_streams: {
    id: number;
    name: string;
  }[];
  date_format_available: string[];
}
export interface AppDetails {
  id: number;
  image: string;
  requiresAuthentication: boolean;
  key: string;
  name: string;
}
export interface IConfigInstanceIdRequest {
  instanceId: string;
  layout?: string;
  duration?: string;
  show_nextweek?: boolean;
}
export interface IConfigInstanceIdResponse {
  id: string;
  name: string;
  configs: AppConfigs;
  app: AppDetails;
  success: boolean;
  data: any;
}
export interface IAppDefaultConfigIdRequest {
  [x: string]: unknown;
  appKey: string;
  configs: any;
}
export interface IGetAllInstanceWithId {
  result: any;
  id: string;
  name: string;
  configs: AppConfigs;
  app: AppDetails;
  fonts: any;
  data: any;
  themes: any;
}

export interface IUpdateInstanceDuration {
  instanceId: string;
  layout?: string;
  duration: number;
  type: string;
}
export interface IUpdateInstanceDurationResponse {}

export const getConfigInstanceId = ({
  instanceId,
  layout,
  duration,
  show_nextweek,
}: IConfigInstanceIdRequest) => {
  const params: Record<string, string | number | boolean | undefined> = {
    layout,
    duration,
  };
  if (show_nextweek === true) params.show_nextweek = true;
  return apiRequest<IConfigInstanceIdRequest, IConfigInstanceIdResponse>(
    "GET",
    `apps/instance/${instanceId}`,
    undefined,
    undefined,
    params
  );
};

export const getDefaultConfig = ({
  appKey,
  configs,
}: IAppDefaultConfigIdRequest) => {
  return apiRequest<IAppDefaultConfigIdRequest, IGetAllInstanceWithId>(
    "POST",
    `apps/preview/${appKey}`,
    configs
  );
};

export const updateDuration = ({
  duration,
  instanceId,
  type,
}: IUpdateInstanceDuration) =>
  apiRequest<any, IUpdateInstanceDurationResponse>(
    "PATCH",
    `apps/instance/${instanceId}/duration`,
    { duration, type }
  );

export interface IDesigner {
  id: string;
  name: string;
  data?: { pages?: any[] };
  tempData?: { pages?: any[] };
  duration?: number;
  isPublished: boolean;
}

export const getDesignerPublic = (
  id: string,
  params?: { duration?: string }
) =>
  apiRequest<undefined, IDesigner>(
    "GET",
    `public/designer/${id}`,
    undefined,
    undefined,
    params
  );
